module.exports = function(s) {
  s = (s === undefined) ? "" : s;
  s = (s === null) ? "" : s;
  s = s.toString();
  return s;
};



//////////////////
// WEBPACK FOOTER
// /home/oksana/sites/bermad/bermad-theme/node_modules/list.js/src/utils/to-string.js
// module id = 10
// module chunks = 0